import sendDataStream from "./sendDataStream";

// services/eventLogger
import logEvent from "services/eventLogger/logEvent";

// utils
import unixTimestampInSeconds from "utils/unixTimestampInSeconds";

// A ---------------------------------------------------------------------- M

const genCdnRecord = async (userID, dataBody, databoxID) => {
  const timestamp = unixTimestampInSeconds();

  try {
    if (!databoxID) {
      console.error("Error in genCDNFileRecord: missing databoxID");
      return {
        success: false,
        error: "Error in genCDNFileRecord: missing databoxID",
      };
    }

    // Data stream
    const result = await sendDataStream(userID, dataBody, timestamp, databoxID);

    if (!result.success) {
      await logEvent(
        databoxID,
        "event_archive_upload_error",
        timestamp,
        "Upload failed.",
        {
          dataType: "CDNFile",
          errorMessage: result.error,
          uploadStatus: false,
        },
        userID
      );
    } else {
      await logEvent(
        databoxID,
        "event_archive_upload_success",
        timestamp,
        "Upload successfully performed.",
        {
          documentID: result.txid,
          dataType: "CDNFile",
          uploadStatus: true,
        },
        userID
      );
    }

    console.log(result);
    return result;
  } catch (error) {
    console.error("Error in genCDNFileRecord:", error);

    if (databoxID) {
      await logEvent(
        databoxID,
        "event_archive_upload_error",
        timestamp,
        "An unexpected error occurred during the upload process.",
        {
          dataType: "CDNFile",
          errorMessage: error.message,
          uploadStatus: false,
        },
        userID
      );
    }

    const result = {
      success: false,
      error: error.message,
    };

    console.log(result);
    return result;
  }
};

export default genCdnRecord;
